/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerBioRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_customer_bio.pb'
import {GetCustomerBioResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_customer_bio.pb'


export const getCustomerBio = (request: GetCustomerBioRequest, options?: CashRequestOptions) => post<GetCustomerBioRequest, GetCustomerBioResponse>("/2.0/cash/get-customer-bio", request, {...options, rejectOnError: true })